import primaryButton from '../../../../primary-button';

const custom = (params) => primaryButton.brandedSolid.background.hover.custom(params);

export default custom;
